import merge from 'lodash/merge';

import { RECEIVE_SLUG_INFO, RECEIVE_SLUG_ERROR, CLEAR_SLUG_ERROR, FETCH_SLUG_INFO, RECEIVE_ASYNC_COMPONENTS } from './page-actions';

/**
 * Store universal page defaults here
 * @type {Object}
 */
const DEFAULT_SLUG_INFO = {
	components: {
		productTab: {}
	},
	customFields: {},
	seo: {
		title: "",
		canonical: "",
		description: "",
		keywords: "",
		robots: false,
		hideCopyBlock: false,
		copyBlock: {},
		categories: [],
		tags: []
	},
	asyncComponentsReceived: false,
	addOns: {

	}
};
const SlugInfoReducer = (state = DEFAULT_SLUG_INFO, action) => {
	Object.freeze(state);
	switch (action.type) {
		case RECEIVE_SLUG_INFO:
			//merge with defaults
			return merge({ fetching: false }, DEFAULT_SLUG_INFO, action.slugInfo);
		case RECEIVE_SLUG_ERROR:
			return merge({}, state, { error: "slug not found" });
		case CLEAR_SLUG_ERROR:
			return merge({}, state, { error: null });
		case FETCH_SLUG_INFO:
			return merge({ fetching: true }, DEFAULT_SLUG_INFO);
		case RECEIVE_ASYNC_COMPONENTS:
			const { components } = action;
			return merge({}, state, { components, asyncComponentsReceived: true });
		default:
			return state;
	}
};

export default SlugInfoReducer;
